import React from 'react';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import { useStyles } from './styles';
interface IProps {
  action: () => void;
  isOpen: boolean;
}

export const CloseIcon = ({ action, isOpen }: IProps) => {
  const classes = useStyles();

  return (
    <ChevronDownIcon
      name="Icon Arrow Down"
      onClick={action}
      className={`${classes.iconArrowDown} ${isOpen ? 'chevronUp' : 'chevronDown'}`}
    />
  );
};
